import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo } from 'react';
import BazaarvoiceReviewCardComponent from './bazaarvoice-review-card.component';
import { ProductReview } from '@spa/generated/graphql/graphql';
import styles from './bazaarvoice-review-list.component.module.scss';
export interface Props {
  readonly reviews: ReadonlyArray<ProductReview>;
}
function BazaarvoiceReviewListComponent(t0) {
  const $ = _c(4);
  const {
    reviews
  } = t0;
  let t1;
  if ($[0] !== reviews) {
    t1 = reviews.map(_temp);
    $[0] = reviews;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className={styles["bazaarvoice-review-list"]}>{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(review) {
  return <BazaarvoiceReviewCardComponent key={review.id} review={review} />;
}
export default memo(BazaarvoiceReviewListComponent);